; (function($, window, document, undefined) {

	var PLUGIN_NAME = 'fixedTable';

	var DEFAULTS = {
		container: null,
		numColumns: 1
	};

	// ----------------------------------------------------------------------------------------------------------------
	// Class definition
	// ----------------------------------------------------------------------------------------------------------------

	function FixedTable(element, options) {
		this.element = element;
		this.$element = $(element);
		this.options = $.extend({}, DEFAULTS, options);

		this.init();
	}

	FixedTable.prototype = {
		init: function() {
			// Make copies
			var $fixedTable = this.$element.clone();
			var $scrollTable = this.$element.clone();

			// Pull out the fixed columns from the original table
			this.removeColsFromTable($scrollTable, 0, this.options.numColumns);
			// Remove all the other rows from the new table
			this.removeColsFromTable($fixedTable, this.options.numColumns);

			var $fixedTableWrapper = $('<div class="table-fixed-content" />').append($fixedTable);
			var $scrollTableWrapper = $('<div class="table-scroll-content" />').append($scrollTable);

			// Silently add the wrapper to the DOM so we can get dimensions
			$([$fixedTableWrapper, $scrollTableWrapper]).css({
				visibility: 'hidden',
				position: 'absolute'
			});

			this.options.container.append($fixedTableWrapper, $scrollTableWrapper);

			// Look at each table and set the heights
			this.matchTableHeights([$fixedTable, $scrollTable]);

			// Remove hiding styles
			$([$fixedTableWrapper, $scrollTableWrapper]).css({
				visibility: 'visible',
				position: 'static'
			});
		},
		getTransformedTable: function() {
			return this.$wrapper;
		},
		matchTableHeights: function(tables) {
			var headCellData = {
				cells: [],
				height: 0
			};
			var bodyRowData = [];

			// Find the tallest heights
			for (var i = 0; i < tables.length; i++) {
				var $table = $(tables[i]);

				// Find the header row height
				var $headCell = $table.find('thead th').first();
				var headerHeight = $headCell.height();
				headCellData.cells.push($headCell);
				headCellData.height = Math.max(headCellData.height, headerHeight);

				// Find the body row height
				$table.find('tbody tr').each(function(x, row) {
					var $cell = $(row).children().first();
					var cellHeight = $cell.height();

					if (!bodyRowData[x]) {
						bodyRowData[x] = {
							cells: [$cell],
							height: cellHeight
						};
					}
					else {
						bodyRowData[x].cells.push($cell);
						bodyRowData[x].height = Math.max(bodyRowData[x].height, cellHeight);
					}
				});
			}

			// Set the header height
			$.each(headCellData.cells, function(x, cell) {
				$(cell).height(headCellData.height);
			});

			// Set the body row heights
			for (var i = 0; i < bodyRowData.length; i++) {
				$.each(bodyRowData[i].cells, function(x, cell) {
					$(cell).height(bodyRowData[i].height);
				});
			}
		},
		removeColsFromTable: function($table, startIndex, endIndex) {
			startIndex = startIndex || 0;
			endIndex = endIndex || $table.find('thead th').length;

			var self = this;

			// Remove the header cells
			this.removeCells(
				$table.find('thead th'),
				startIndex,
				endIndex
			);

			// Remove the body cells
			$table.find('tbody tr').each(function(i, row) {
				self.removeCells(
					$(row).children(),
					startIndex,
					endIndex
				);
			});
		},
		removeCells: function(cells, startIndex, endIndex) {
			var subset = cells.slice(startIndex, endIndex);

			for (var i = 0; i < subset.length; i++) {
				$(subset[i]).remove();
			}
		}
	};

	// ----------------------------------------------------------------------------------------------------------------
	// Plugin api
	// ----------------------------------------------------------------------------------------------------------------

	$.fn[PLUGIN_NAME] = function(options) {
		return this.map(function() {
			if (!$.data(this, "plugin_" + PLUGIN_NAME)) {
				var instance = new FixedTable(this, options);
				$.data(this, "plugin_" + PLUGIN_NAME, instance);
				return instance.getTransformedTable();
			}
		});
	};

})(jQuery, window, document);